<template>
  <div class="px-8 py-6" style="height:100%; width:100%;">
    <h3>현장관리</h3>
    <div class="d-flex pt-5 pb-5">
      <div class="pr-5">
        <v-select
          v-resize="updateWindowHeight"
          :items="selectCategory"
          v-model="searchCategory"
          height="28"
          label="현장명"
          solo
          flat
          dense
          class=" width160-height30 border-5c5c5c"
          :menu-props="{ offsetY: true }"
        />
      </div>
      <div class="pr-5">
        <input
          type="text"
          class="border-width back-white border-5c5c5c"
          style="height:30px; width:300px;"
          v-model="searchWord"
          @keyup.enter="searchConstruction"
        />
      </div>
      <v-btn
        width="78"
        height="30"
        color="#3F557D"
        class="color-white"
        @click="searchConstruction"
        >조회
      </v-btn>
      <v-spacer />
      <v-btn
        width="120"
        height="30"
        color="#6C98EB"
        class="color-white"
        @click="$router.push({ name: 'AddConstruction' })"
        v-if="userState == '시스템관리자'"
        >현장추가
      </v-btn>
    </div>
    <div class="pt-3 ">
      <v-simple-table
        class="text-center width-100"
        fixed-header
        :height="windowInnerHeight - 48 - 225"
        dense
      >
        <thead>
          <tr class="color-white back-8ca9dd">
            <th
              class="color-white back-8ca9dd text-center border-right-white"
              v-for="item in header"
              :key="item"
            >
              {{ item }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="list in constructionList" :key="list.constName">
            <td
              class="border-left-aaaaaa border-right-aaaaaa border-bottom-aaaaaa  color-0038FF back-f5f5f5 text-left"
              style="width:500px"
            >
              <v-btn
                @click="updateConstruction(list.constructionId)"
                color="#0038FF"
                class="text-left"
                text
              >
                {{ list.constructionName }}
              </v-btn>
            </td>
            <td class="border-right-aaaaaa border-bottom-aaaaaa">
              {{ list.startDate ? fotmatDate(list.startDate) : "-" }}
            </td>
            <td class="border-right-aaaaaa border-bottom-aaaaaa">
              {{ list.endDate ? fotmatDate(list.endDate) : "-" }}
            </td>
            <td
              class="border-right-aaaaaa border-bottom-aaaaaa"
              :style="statusColor(list.completion)"
            >
              {{ list.completion }}
            </td>
            <td class="color-5BB1EA border-right-aaaaaa border-bottom-aaaaaa">
              <div
                class="ma-0 pa-0 "
                v-for="(i, index) of splitMethod(list.constructionAdmin)"
                :key="index"
              >
                <span class="ml-3">{{ "· " + i }}</span>
              </div>
            </td>
            <td class="border-right-aaaaaa border-bottom-aaaaaa">
              <div
                class="ma-0 pa-0 "
                v-for="(i, index) of splitMethod(list.phoneNumber)"
                :key="index"
              >
                <span class="ml-3">{{ "· " + i }}</span>
              </div>
            </td>
            <td class="border-right-aaaaaa border-bottom-aaaaaa">
              {{ list.regDate | moment("YY.MM.DD") }}
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </div>
    <div class="justify-center d-flex pt-5">
      <v-pagination
        v-model="constPage"
        :length="constPageLength"
        color="#8EB4FA"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import ConstApi from "@/api/ConstructionService";
import Commonality from "@/mixin/Commonality";
import moment from "moment";

export default {
  mixins: [Commonality],

  data: () => ({
    selectCategory: ["현장명", "공사 현황", "현장 담당자", "전화번호"],
    searchItems: ["차수", "부위", "구분", "입고현황"],
    searchWord: "",
    page: 1,
    constPage: 1,
    constPageLength: 1,
    constructionList: [],
    constructionTotalList: [],
    searchCategory: "",
    header: [
      "현장명",
      "착공일",
      "준공일",
      "공사 현황",
      "현장 담당자",
      "담당자 전화번호",
      "등록일자",
    ],
    windowInnerHeight: 0,
  }),

  async created() {
    this.startAndReset();

    this.$bus.$on("constructionNavigationDuplicated", () => {
      this.startAndReset();
    });
  },

  beforeDestroy() {
    this.$bus.$off("constructionNavigationDuplicated");
  },

  methods: {
    fotmatDate(date) {
      return moment(date).format("YY.MM.DD");
    },
    /** 윈도우 동적높이 가져오는 함수 */
    updateWindowHeight() {
      if (typeof window !== "undefined") {
        this.windowInnerHeight = window.innerHeight;
      }
    },
    async startAndReset() {
      let data = {
        constructionId: 0,
      };
      if (this.userState == "현장관리자")
        data.constructionId = this.constructionId;
      let reData = await ConstApi.constructionTotalList(data);
      this.constructionTotalList = reData.data.constList;

      this.constructionList = this.constructionTotalList;
      this.searchCategory = "현장명";
    },

    statusColor(val) {
      return (
        "color:" +
        (val == "시공중"
          ? "#FF0000"
          : val == "시공완료"
          ? "#37AC00"
          : "#888888")
      );
    },

    splitMethod(val) {
      if (val) return (val + "").split(",");
      else return "";
    },
    updateConstruction(data) {
      this.$router.push({
        name: "AddConstruction",
        params: {
          constructionId: data,
        },
      });
    },

    searchConstruction() {
      if (this.searchWord == "")
        return (this.constructionList = this.constructionTotalList);
      if (this.searchCategory == "공사 현황") {
        this.constructionList = this.constructionTotalList.filter(
          (constructionList) =>
            constructionList.completion
              ? constructionList.completion.includes(this.searchWord)
              : false
        );
      } else if (this.searchCategory == "현장명") {
        this.constructionList = this.constructionTotalList.filter(
          (constructionList) =>
            constructionList.constructionName
              ? constructionList.constructionName.includes(this.searchWord)
              : false
        );
      } else if (this.searchCategory == "현장 담당자") {
        this.constructionList = this.constructionTotalList.filter(
          (constructionList) =>
            constructionList.constructionAdmin
              ? constructionList.constructionAdmin.includes(this.searchWord)
              : false
        );
      } else if (this.searchCategory == "전화번호") {
        this.constructionList = this.constructionTotalList.filter(
          (constructionList) =>
            constructionList.phoneNumber
              ? constructionList.phoneNumber.includes(this.searchWord)
              : false
        );
      }
    },
  },
};
</script>

<style scoped>
.v-data-table--fixed-header.v-data-table--dense
  > .v-data-table__wrapper
  > table
  > thead {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 10;
}
.v-text-field {
  height: 32px !important;
}

.border-width {
  width: 529px;
  height: 42px;
}

.width160-height30 {
  width: 160px !important;
  height: 30px !important;
}

@media (max-width: 1000px) {
  .width-100 {
    width: 1605px !important;
  }
}
</style>
